import { createSlice } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist/src/constants';
import requestStatus from 'common/constants/status';

const initialState = {
  data: {
    myTickets: [],
    adminTickets: [],
    paginatorInfo: null,
    current: null
  },
  status: {
    listMine: requestStatus.idle,
    listAdmin: requestStatus.idle,
    find: requestStatus.idle,
    create: requestStatus.idle,
    reply: requestStatus.idle,
    updateStatus: requestStatus.idle
  }
};

const pqrsSlice = createSlice({
  name: 'pqrs',
  initialState,
  reducers: {
    // Cliente: sus tickets
    listMine(state) {
      state.status.listMine = requestStatus.loading;
    },
    listMineSuccess(state, action) {
      state.status.listMine = requestStatus.success;
      state.data.myTickets = action.payload;
    },
    listMineError(state) {
      state.status.listMine = requestStatus.error;
    },

    // Admin: todos los tickets (paginado)
    listAdmin(state) {
      state.status.listAdmin = requestStatus.loading;
    },
    listAdminSuccess(state, action) {
      state.status.listAdmin = requestStatus.success;
      state.data.adminTickets = action.payload.data;
      state.data.paginatorInfo = action.payload.paginatorInfo;
    },
    listAdminError(state) {
      state.status.listAdmin = requestStatus.error;
    },

    // Un ticket (hilo)
    find(state) {
      state.status.find = requestStatus.loading;
    },
    findSuccess(state, action) {
      state.status.find = requestStatus.success;
      state.data.current = action.payload;
    },
    findError(state) {
      state.status.find = requestStatus.error;
    },

    // Crear ticket (cliente)
    create(state) {
      state.status.create = requestStatus.loading;
    },
    createSuccess(state, action) {
      state.status.create = requestStatus.success;
      state.data.current = action.payload;
    },
    createError(state) {
      state.status.create = requestStatus.error;
    },

    // Responder (cliente/admin)
    reply(state) {
      state.status.reply = requestStatus.loading;
    },
    replySuccess(state, action) {
      state.status.reply = requestStatus.success;
      state.data.current = action.payload;
    },
    replyError(state) {
      state.status.reply = requestStatus.error;
    },

    // Cambiar estado (admin)
    updateStatus(state) {
      state.status.updateStatus = requestStatus.loading;
    },
    updateStatusSuccess(state, action) {
      state.status.updateStatus = requestStatus.success;
      state.data.current = action.payload;
    },
    updateStatusError(state) {
      state.status.updateStatus = requestStatus.error;
    },

    clearCurrent(state) {
      state.data.current = null;
    },
    resetStatus(state) {
      state.status = initialState.status;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
  }
});

export default pqrsSlice;
